import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {addEditProduct, delProduct, getProducts} from '../../services';
import {IProduct, IProductFilter, IProductRes, IProductState} from "../types/IProduct";
import historyHelper from "../../helpers/history";
import {AppState} from "./rootReducer";

const initialState: IProductState = {
    status: "idle"
}

export const mostrarProducts = createAsyncThunk(
    'mostrarProducts', async (params:IProductFilter|undefined, thunkAPI ) => {
        const {products} = thunkAPI.getState() as AppState;
        let paramsFilter = params || products.filtered;

        const response = await getProducts(paramsFilter)
        return {data: response.data as IProductRes, params: response.config.params}
    }
)

export const agregarEditarProduct = createAsyncThunk(
    'Products/agregarEditar', async (product: IProduct) => {
        const response = await addEditProduct(product);
        if (response.status === 200 || response.status === 204) historyHelper.back();
        return {data: response.data, edit:!!product.id};
    }
);

export const eliminarProduct = createAsyncThunk(
    'product/eliminar', async (id: number) => {
        const response = await delProduct(id);
        if (response.status === 200 || response.status === 204) historyHelper.back();
        return id;
    }
);


const slice = createSlice({
    name: 'mostrarProducts',
    initialState,
    reducers: {
    },
    extraReducers: builder => {
        //--mostrarProducts
        builder.addCase(mostrarProducts.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(mostrarProducts.fulfilled, (state,action ) => {
            state.status = "idle";
            state.filtered = action.payload.params;
            state.list = action.payload.data;
        })
        builder.addCase(mostrarProducts.rejected, (state ) => {
            state.status = "idle";
        })

        //--agregarEditarProduct
        builder.addCase(agregarEditarProduct.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(agregarEditarProduct.fulfilled, (state,action ) => {
            state.status = "idle";
            if(state.list){
                state.list.items = state.list?.items.filter(e => e.id !== action.payload.data.id);
                state.list.items.unshift(action.payload.data);
                if(!action.payload.edit){
                    ++state.list.pageSize
                    ++state.list.totalCount
                }

            }
        })
        builder.addCase(agregarEditarProduct.rejected, (state ) => {
            state.status = "idle";
        })
        //--eliminarProduct
        builder.addCase(eliminarProduct.pending, (state ) => {
            state.status = "loading";
        })
        builder.addCase(eliminarProduct.fulfilled, (state,action ) => {
            state.status = "idle";
            const id = action.payload;
            if(state.list?.items){
                state.list.items = state.list?.items.filter(e => e.id !== id)
            }
        })
        builder.addCase(eliminarProduct.rejected, (state ) => {
            state.status = "idle";
        })
    }
});

export default slice.reducer;
